import { render, staticRenderFns } from "./PersonEditDetail.vue?vue&type=template&id=6b2accfd&scoped=true"
import script from "./PersonEditDetail.vue?vue&type=script&lang=js"
export * from "./PersonEditDetail.vue?vue&type=script&lang=js"
import style0 from "./PersonEditDetail.vue?vue&type=style&index=0&id=6b2accfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2accfd",
  null
  
)

export default component.exports